import { render, staticRenderFns } from "./local-search.vue?vue&type=template&id=16650345"
import script from "./local-search.vue?vue&type=script&lang=js"
export * from "./local-search.vue?vue&type=script&lang=js"
import style0 from "./local-search.vue?vue&type=style&index=0&id=16650345&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports